module.exports = __webpack_public_path__ + "javascript.872cfa.svg";